var body = document.body;

//Frage zum Produkt
var product_modal = document.getElementById("productpage-question-modal");
var product_btn = document.getElementById("product-question-btn");
var product_span = document.getElementsByClassName("product-question-close")[0];

product_btn.onclick = function(a) {
  a.preventDefault();
  product_modal.classList.add("open");
  body.classList.add("tfm_modal");
}

product_span.onclick = function() {
  product_modal.classList.remove("open");
  body.classList.remove("tfm_modal");
}

window.onclick = function(event) {
  if (event.target == product_modal) {
    product_modal.classList.remove("open");
    body.classList.remove("tfm_modal");
  }
}

//Telefonkontakt
var product_phone_modal = document.getElementById("phone-modal");
var product_phone_btn = document.getElementById("product-phone-btn");
var product_phone_span = document.getElementsByClassName("phone-close")[0];

product_phone_btn.onclick = function(a) {
  a.preventDefault();
  product_phone_modal.classList.add("open");
  body.classList.add("tfm_modal");
}

product_phone_span.onclick = function() {
  product_phone_modal.classList.remove("open");
  body.classList.remove("tfm_modal");
}

window.onclick = function(event) {
  if (event.target == product_phone_modal) {
    product_phone_modal.classList.remove("open");
    body.classList.remove("tfm_modal");
  }
}


// Success Form
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};


var form_success = getUrlParameter('contact_posted');
var success_modal = document.getElementById("success-offer-modal");
var success_span = document.getElementsByClassName("success-offer-close")[0];
  
success_span.onclick = function() {
	success_modal.classList.remove("open");
  	body.classList.remove("tfm_modal");
}

window.onclick = function(event) {
  if (event.target == success_modal) {
    success_modal.classList.remove("open");
    body.classList.remove("tfm_modal");
  }
}

if (form_success == 'true') {
  	success_modal.classList.add("open");
  	body.classList.add("tfm_modal");
  	window.history.replaceState({}, document.title, "/");
}